import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaSearch, FaPercent, FaClipboardCheck, FaCalendarCheck, FaCalendarAlt, FaMoneyBillWave, FaCreditCard, FaShieldAlt, FaUserTie, FaRocket } from 'react-icons/fa';

/**
 * Tamamen modüler ve özelleştirilebilir SalesSystem bileşeni
 * @param {Object} props - Bileşen özellikleri
 * @param {boolean} props.showBanner - Banner bölümünü göster/gizle
 * @param {boolean} props.showSteps - Adımlar bölümünü göster/gizle
 * @param {boolean} props.showStepsTitle - Adımlar bölümünün başlığını göster/gizle
 * @param {boolean} props.showAdvantages - Avantajlar bölümünü göster/gizle
 * @param {boolean} props.showFAQ - SSS bölümünü göster/gizle
 * @param {boolean} props.showCTA - CTA bölümünü göster/gizle
 * @param {string} props.stepsTitle - Adımlar bölümü başlık metni
 * @param {string} props.advantagesTitle - Avantajlar bölümü başlık metni
 * @param {string} props.faqTitle - SSS bölümü başlık metni
 * @param {string} props.ctaId - CTA butonu için sayfa içi bağlantı ID'si
 */
const SalesSystem = ({
    //showBanner = true,
    showSteps = true,
    showStepsTitle = false,
    showAdvantages = true,
    showFAQ = true,
    showCTA = true,
    stepsTitle = "Kredi Başvuru Süreci",
    advantagesTitle = "Neden Otoprime?",
    faqTitle = "Sık Sorulan Sorular",
    ctaId = "sales-system-cta"
}) => {
    // Araç alım süreci adımları - Modern ikonlarla
    const salesSteps = [
        {
            id: 1,
            icon: <FaSearch />,
            title: "Aracınızı Seçin",
            description: "Binlerce araç seçeneği arasından size en uygun olanı bulun",
            color: "from-blue-500 to-blue-600"
        },
        {
            id: 2,
            icon: <FaPercent />,
            title: "Peşinatınızı Belirleyin", 
            description: "Minimum %30 peşinatla hemen başvurunuzu yapın",
            color: "from-green-500 to-green-600"
        },
        {
            id: 3,
            icon: <FaClipboardCheck />,
            title: "Başvurunuz Onaylansın",
            description: "Hızlı değerlendirme ile 24 saat içinde yanıt alın",
            color: "from-purple-500 to-purple-600"
        },
        {
            id: 4,
            icon: <FaCalendarCheck />,
            title: "Aracınızı Teslim Alın",
            description: "Esnek taksit seçenekleri ile keyfinize bakın",
            color: "from-orange-500 to-red-500"
        }
    ];

    // Otoprime'in sağladığı avantajlar
    const advantages = [
        {
            icon: <FaRocket />,
            text: "Hızlı ve kolay başvuru süreci",
            description: "Sadece 5 dakikada başvurunuzu tamamlayın"
        },
        {
            icon: <FaCalendarAlt />,
            text: "Esnek ödeme planları",
            description: "Size uygun vade seçenekleri"
        },
        {
            icon: <FaMoneyBillWave />,
            text: "48 aya varan vade seçenekleri",
            description: "Uzun vadeli ödeme kolaylığı"
        },
        {
            icon: <FaCreditCard />,
            text: "Senetle ödeme imkanı",
            description: "Kredi kartına gerek yok"
        },
        {
            icon: <FaShieldAlt />,
            text: "Şeffaf fiyatlandırma",
            description: "Gizli masraf yok, net fiyat"
        },
        {
            icon: <FaUserTie />,
            text: "Profesyonel danışmanlık",
            description: "Uzman ekibimiz yanınızda"
        }
    ];

    // SSS (Sık Sorulan Sorular)
    const faqs = [
        {
            question: "Otoprime'dan kimler araç satın alabilir?",
            answer: "18 yaşını doldurmuş, düzenli gelir sahibi ve gerekli belgeleri sağlayabilen herkes Otoprime'dan araç satın alabilir."
        },
        {
            question: "Başvuru için hangi belgelere ihtiyacım var?",
            answer: "Kimlik fotokopisi, ikametgah belgesi, gelir belgesi ve peşinat ödeme dekontu gibi temel belgeler gerekmektedir. Başvuru sırasında detaylı bilgi verilecektir."
        },
        {
            question: "Aylık ödeme tutarımı nasıl öğrenebilirim?",
            answer: "Ana sayfamızdaki ödeme hesaplama aracını kullanarak, seçtiğiniz araç ve vade için aylık ödeme tutarınızı öğrenebilirsiniz."
        },
        {
            question: "Araç teslim süresi ne kadardır?",
            answer: "Başvurunuzun onaylanmasını takiben, genellikle 3-5 iş günü içerisinde aracınızı teslim alabilirsiniz."
        }
    ];

    return (
        <div className="sales-system-page">

            {/* Nasıl Çalışır Bölümü */}
            {showSteps && (
                <section className="modern-steps-section py-5">
                    <Container>
                        {showStepsTitle && (
                            <div className="text-center mb-5">
                                <h2 className="section-title">{stepsTitle}</h2>
                                <p className="lead">4 kolay adımda hayalinizdeki araca sahip olun</p>
                            </div>
                        )}

                        <Row className="g-4">
                            {salesSteps.map((step, index) => (
                                <Col lg={3} md={6} className="mb-4" key={step.id}>
                                    <div className="modern-step-card">
                                        <div className="step-number">{step.id}</div>
                                        <div className="step-icon-modern">{step.icon}</div>
                                        <h4 className="step-title-modern">{step.title}</h4>
                                        <p className="step-description-modern">{step.description}</p>
                                        {index < salesSteps.length - 1 && (
                                            <div className="step-connector d-none d-lg-block"></div>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>

                        <div className="text-center mt-5">
                            <Button as={Link} to="/application" className="apply-btn-black">
                                Hemen Başvur <FaArrowRight className="ms-2" />
                            </Button>
                        </div>
                    </Container>
                </section>
            )}

            {/* Avantajlar Bölümü */}
            {showAdvantages && (
                <section className="modern-advantages-section py-5 bg-light">
                    <Container>
                        <div className="text-center mb-5">
                            <h2 className="section-title">{advantagesTitle}</h2>
                            <p className="lead">Otoprime'ı tercih etmeniz için 6 önemli neden</p>
                        </div>

                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <Row className="g-4">
                                    {advantages.map((advantage, index) => (
                                        <Col md={6} key={index}>
                                            <div className="modern-advantage-card">
                                                <div className="advantage-icon-modern">{advantage.icon}</div>
                                                <div className="advantage-content">
                                                    <h5 className="advantage-title-modern">{advantage.text}</h5>
                                                    <p className="advantage-description-modern">{advantage.description}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                            <Col lg={4} className="d-flex align-items-center justify-content-center mt-4 mt-lg-0">
                                <img
                                    src="/images/why.jpg"
                                    alt="Otoprime Avantajları"
                                    className="img-fluid advantages-image-modern"
                                />
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Sık Sorulan Sorular */}
            {showFAQ && (
                <section className="modern-faq-section py-5">
                    <Container>
                        <div className="text-center mb-5">
                            <h2 className="section-title">{faqTitle}</h2>
                            <p className="lead">Merak ettiklerinizin yanıtları burada</p>
                        </div>

                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <div className="modern-faq-list">
                                    {faqs.map((faq, index) => (
                                        <div className="modern-faq-item" key={index}>
                                            <h4 className="modern-faq-question">{faq.question}</h4>
                                            <p className="modern-faq-answer">{faq.answer}</p>
                                        </div>
                                    ))}
                                </div>

                                <div className="text-center mt-5">
                                    <p className="text-muted">Daha fazla soru için bize ulaşın</p>
                                    <Button variant="outline-dark" size="lg" as={Link} to="/contact">
                                        İletişime Geç
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Başvuru CTA Bölümü */}
            {showCTA && (
                <section id={ctaId} className="modern-cta-section py-5">
                    <Container className="text-center">
                        <div className="cta-content-modern">
                            <h2 className="cta-title-modern">Hayalinizdeki araca hemen kavuşun!</h2>
                            <p className="cta-description-modern">Otoprime'ın avantajlı satış sistemi ile senetle araç sahibi olmak için hemen başvurun.</p>
                            <Button as={Link} to="/apply" className="apply-btn-black">
                                Hemen Başvur <FaArrowRight className="ms-2" />
                            </Button>
                        </div>
                    </Container>
                </section>
            )}
        </div>
    );
};

export default SalesSystem;
